'use strict';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  elements: [],
  history: [],
  elementAnsweredAt: {}
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
